export type ProviderAddressType = 'private' | 'business';
export type OfferType = 'ROOM' | 'MATERIAL';

export interface PlatformAdminOffer {
  id: string;
  name?: string | null;
  type: OfferType;
  visible: boolean;
  publishedAt?: number | null;
  deleted?: boolean;
  temporarilySuspended?: boolean;
  suspensionReviewRequested?: boolean;
  removalReason?: string | null;
  removalMessageToProvider?: string | null;
  providerName?: string | null;
  providerEmail?: string | null;
  providerAddressType?: ProviderAddressType | null;
  organizationId: string;
  organizationName?: string | null;
  bookingCount: number;
  bookingRequestCount: number;
}

export const isBusinessOfferMissingOrganization = (
  offer: PlatformAdminOffer
): boolean =>
  offer.providerAddressType === 'business' && !offer.organizationName?.trim();

export interface PlatformAdminOfferPage {
  number: number;
  numberOfElements: number;
  totalElements: number;
  totalPages: number;
  size: number;
  content: PlatformAdminOffer[];
}

export interface SuspendOfferRequest {
  reason: string;
  messageToProvider?: string;
}
